import { ViewGroup } from '../model/view-group.model';
import { TranslationKeyMap } from '../task-list-dialog.i18n';

export const groups: ViewGroup[] = [
    {
        label: TranslationKeyMap._9569_TODAY,
        open: true,
        tasks: [],
    },
    {
        label: TranslationKeyMap._11231_THIS_WEEK,
        open: true,
        tasks: [],
    },
    {
        label: TranslationKeyMap._11232_FUTURE,
        open: true,
        tasks: [],
    },
    {
        label: TranslationKeyMap._7223_COMPLETED,
        open: true,
        tasks: [],
    },
];
